var sentinel = {
  "shipping": '',
  "shipping_selected": '',  
  "terms": false,
  "validate": function() {  
    var return_val =  ( this.terms && ( this.shipping !== '' ) && this.form_complete()  );
    return_val = return_val && !this.shipping_charge_missing();
    return return_val;
  },
  "form_complete": function() {
    var option = $('#' + this.shipping)
    var content = option.siblings('.sub-div').find('.content');
    var form_fields = content.find('input, select');
    var result = true;

    $.each(form_fields, function(index, element) {
      if (!$(element).val()) {
        result = false;
        $(element).addClass('bad-form-field');
      }
   
        if ($(element).attr('id') == 'work-address-zip-code') {    
          if (!($.isNumeric($(element).val()) ) ) {
            result = false;      
            $(element).addClass('bad-form-field');        
          }
        }

    });

    return result;
  },
  
  "shipping_charge_missing": function() {
    var rate_text = jQuery('#cart-shipping-total').text().replace(",", "");
    var result = false;
    
    if (rate_text.length > 0 )
    {
    var rate = parseInt(rate_text) / 100;    
    result = rate > 2;
    }
    
    no_shipping = (!this.requires_shipping() || $("#afhent-i-torvehallerne-kbh-4").attr('checked') == "checked");
    
    var total_price = parseFloat($("#total_price").html());
    
    // free shipping
    
    if (total_price >= 54800)
      no_shipping = true;
    
    shipping_rate_missing = !result && !no_shipping;
    if (shipping_rate_missing)
    {
      //clear shipping
      sentinel.shipping = "";
      sentinel.shipping_selected = "";
      $('.shipping-category-block input:radio').each(function(){
        $(this).attr('checked', false);
      });
      
      $('.shipping-category-block.active').removeClass("active");
      
      $('.shipping-category-block .sub-div').hide();                  
      $('.shipping-rates .tick img').hide();
            
      alert("Vælg venligst leveringsmetode");
    }

    return shipping_rate_missing;
  },
  
  "requires_shipping": function() {
  
    var requires_shipping = false;
     $(".cart_page_table tr p.requires-shipping").each(function (index) {
       var cell_text = this.innerHTML;
       requires_shipping = requires_shipping || (cell_text =="true");
     }
     );
     
     return requires_shipping;
  },
  
};
